type Crumb = { label: string; to?: string };

type BreadcrumbsProps = {
  items: Crumb[];
};

const SITE = "https://makershub.be";

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.label,
      item: c.to ? `${SITE}${c.to}` : undefined,
    })),
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}
